import { render } from "./TIMOE_TIMG.vue?vue&type=template&id=f1d48dc8&scoped=true"
import script from "./TIMOE_TIMG.vue?vue&type=script&lang=js"
export * from "./TIMOE_TIMG.vue?vue&type=script&lang=js"

import "./TIMOE_TIMG.vue?vue&type=style&index=0&id=f1d48dc8&lang=css"
import "./TIMOE_TIMG.vue?vue&type=style&index=1&id=f1d48dc8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1d48dc8"]])

export default __exports__